import React from 'react';
import { getWavePeriodClass } from '../../../utils/helpers';

const SwellWavePeriodRow = ({dayData, units, data}) => {

    return (
        <tr className="hover:bg-custom-darker/50 transition-colors">
            <td className="pl-2 py-1 text-xs text-custom-light-grey ">
                <div className="inline-flex items-center gap-2 font-medium">
                    <div>
                        <span className="block sm:hidden">Swell&nbsp;P</span>
                        <span className="hidden sm:inline-block">Swell Period&nbsp;</span>
                        {units &&<span className="text-custom-light-grey/70">({units})</span>}
                    </div>
                </div>
            </td>
            {dayData.map(({ index }) => {
                const swellPeriod = data?.[index];
                // Color code period values (longer periods are generally better for surfing)
                const periodClass = getWavePeriodClass(swellPeriod);
                return (
                    <td key={index} className="py-1 text-center">
                        <div className={`inline-block min-w-[30px] text-center text-sm font-medium ${periodClass}`}>
                            {/* remove decimal and round off */}
                            {Math.round(swellPeriod)}
                        </div>
                    </td>
                );
            })}
        </tr>
    )
}

export default SwellWavePeriodRow;